import React from "react";
import '../../Pages/Gastronomia/gastronomia.css'; //TODO: own css file.
import { useState, useRef } from "react";
import {ReactComponent as SearchIcon} from '../../assets/imgs/shops/filter/search.svg';
import FilterButton from "./FilterButton";

//send textinput to parent through callback function
function FilterBar ({handleSearch}) {

    const typeFilter = useRef("");
    const [searchTerm, setSearchTerm] = useState("");

    const observeButtonClick = () => {

    }

    const handleFilterToggle = (type)  => {

        typeFilter.current = type;
        handleSearch(searchTerm);
    }
    return (
        <>
        <div className="filter-bar-wrapper">
            <div className="filter-buttons-container">
                <FilterButton>TODO</FilterButton>
            </div>
            <div className="search-container">
                <div style={{zIndex: 2, position: 'relative'}}>
                <input className="filter-search-bar"
                placeholder="BUSCAR"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
                >
                </input>
                </div>
                <div className="search-icon-div">
                    <div className="search-icon">
                        <SearchIcon/>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default FilterBar;